import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs';

import { IHeading, PositionEnum, SdHeadingComponent, SdSpyTargetDirective,
  SizesEnum, ThemesTextEnum
} from '@seb/web-design-system/core';

import { transformHeadlineLevelToTitleLevel } from '../../../mappers';
import { AbstractComponent } from '../abstract-component.component';
import { ComponentService, ImageService } from '../../../services';
import { EditorialComponentInterface } from '../../../models';

@Component({
  selector: 'wc-editorial',
  templateUrl: './editorial.component.html',
  styleUrls: ['./editorial.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdHeadingComponent,
    SdSpyTargetDirective
  ]
})
export class EditorialComponent extends AbstractComponent<EditorialComponentInterface> implements OnInit {
  @Input() class = '';

  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'wc-title is-cms'].filter(Boolean).join(' ');
  }

  heading: IHeading;
  readMore: boolean;
  titleLevel: number;
  headline?: string;
  subline?: string;
  isUnderlined = false;
  size: SizesEnum = SizesEnum.l;
  theme: ThemesTextEnum;
  textConfig: PositionEnum = PositionEnum.center;

  constructor(
    private componentService: ComponentService,
    private cdRef: ChangeDetectorRef,
    private imageService: ImageService
  ) {
    super();
  }

  override mandatoryFunction = (cmp: EditorialComponentInterface): boolean => {
    return !!cmp.headline;
  };

  ngOnInit(): void {
    this.component$
      .pipe(this.componentService.reloadComponentForArrayProperties(['pictos']), takeUntil(this.destroy$))
      .subscribe((cmp: EditorialComponentInterface) => {
        this.heading = this.toWrapperHeading(cmp);
        this.isUnderlined = cmp.isUnderlined === 'true';
        this.size = (cmp.size?.toLowerCase() as SizesEnum) || this.size;
        this.titleLevel = transformHeadlineLevelToTitleLevel(cmp.headlineLevel);
        this.readMore = cmp.readmore === 'true';
        this.theme = ThemesTextEnum[cmp.theme?.toLowerCase()];
        this.textConfig = (cmp.editorialTextConfig?.toLowerCase() as PositionEnum) || this.textConfig;

        this.setLoaded();
        this.cdRef.markForCheck();
      });
  }

  toWrapperHeading(cmp: EditorialComponentInterface): IHeading {
    if (cmp.headline || cmp.subline) {
      return {
        title: cmp.headline,
        subtitle: cmp.subline,
        description: cmp.description,
        media: cmp.media ? this.imageService.normalizeMedia(cmp.media) : undefined,
        mediaSize: (cmp.mediaSize?.toLowerCase() as SizesEnum.l) || undefined
      };
    }
    return undefined;
  }
}
